// extracted by mini-css-extract-plugin
module.exports = {"colorSelector":"ObjectColorSelector_colorSelector__2zxVo"};